import { Envelope } from "./Envelope";

export interface Suburb {
    SuburbId : number;
    SuburbName : string;
    geometry : any;
    extents : Envelope;
}

export function isSuburb(object: any) : object is Suburb {	
    return 'SuburbId' in object && 
        'SuburbName' in object;	
}
